"use client";

import { cn } from "@/lib/utils";
import { DISCOVERY_DECADES, type DiscoveryDecade } from "@garimpa/lib/discoveryDecades";

interface DecadeSelectorProps {
  compact?: boolean;
  value: DiscoveryDecade | undefined;
  onChange: (value: DiscoveryDecade | undefined) => void;
}

export function DecadeSelector({ compact = false, value, onChange }: DecadeSelectorProps) {
  return (
    <div
      className={cn(
        "flex gap-2 sm:gap-2.5",
        compact
          ? "overflow-x-auto pb-1 [scrollbar-width:none] sm:flex-wrap sm:overflow-visible sm:pb-0 [&::-webkit-scrollbar]:hidden"
          : "flex-wrap",
      )}
    >
      {DISCOVERY_DECADES.map((decade) => {
        const active = value === decade.startYear;
        return (
          <button
            key={decade.startYear}
            type="button"
            aria-pressed={active}
            onClick={() => onChange(active ? undefined : decade.startYear)}
            className={cn(
              "min-h-11 shrink-0 rounded-full border px-4 py-2 sm:min-h-10 text-sm font-semibold transition-colors",
              compact && "px-3 text-xs sm:px-4 sm:text-sm",
              active
                ? "border-primary/30 bg-primary/10 text-primary"
                : "border-border bg-secondary/50 text-foreground/90 hover:border-border/80 hover:text-foreground",
            )}
          >
            {decade.label}
          </button>
        );
      })}
    </div>
  );
}
